<template>
  <main id="authorEvents" v-if="isAuthed">
    <Toolbars ref="toolbars"
      :status="config.status"
      :authors="store.authors"
      :arrangers="store.arrangers"
      @emit="emitted"
    />
    <v-list class="transparent">
      <v-list-item v-if="$vuetify.breakpoint.smAndUp">
        <v-row>
          <v-col cols="2" class="text-center primary font-weight-black blue-grey--text- text--darken-3">予定日</v-col>
          <v-col cols="8" class="text-left primary font-weight-black blue-grey--text- text--darken-3">予定内容</v-col>
          <v-col cols="2" class="text-center primary font-weight-black blue-grey--text- text--darken-3">留学の種類</v-col>
        </v-row>
      </v-list-item>
      <v-progress-linear v-if="isLoading" class="ma-0" indeterminate color="blue"></v-progress-linear>
      <template v-for="item in getItems">
        <v-list-item :key="item.id" class="it-hv" :to="`../client/${item.cid}`" target="_blank">
          <v-row>
            <v-col cols="2" class="text-center text-truncate">{{ item.date }}</v-col>
            <v-col cols="8" class="text-left text-truncate">{{ item.summary }}</v-col>
            <v-col cols="2" class="text-center text-truncate">{{ item.arrange }}</v-col>
          </v-row>
        </v-list-item>
        <v-divider :key="item.id + '_div'"></v-divider>
      </template>
    </v-list>
  </main>
</template>

<script>
import Toolbars from './toolbars'
export default {
  name: 'authorEvents',
  components: {
    Toolbars
  },
  data () {
    return {
      config: {
        status: {
          loading: false,
          authed: false
        }
      },
      meta: {
      },
      form: {
        page: 1,
        limit: 10
      },
      store: {
        events: []
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$set(this.config.status, 'authed', true)
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (fm) {
      if (fm) {
        this.$set(this, 'form', fm)
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}calendar/get/clients`, fm, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$set(this.store, 'events', res.data.data.items)
              this.$refs.toolbars.count(res.data.data.items.length)
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    page: function (req) {
      this.$set(this, 'form', req)
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    },
    isDevMode () {
      return this.$store.getters['author/get']('dev')
    },
    isLoading () {
      return this.config.status.loading
    },
    getItems () {
      const { page, limit } = { page: this.form.page, limit: parseInt(this.form.limit) }
      console.log(`page: ${page} limit: ${limit}`)
      return this.store.events.length ? this.store.events.map(it => {
        const { id, summary, start, extendedProperties } = it
        const privateData = extendedProperties ? extendedProperties.private : {}
        const { arrange, cid } = privateData || { arrange: '', cid: '' }
        return {
          id,
          cid,
          summary,
          date: this.$moment(start.dateTime || start.date).format('YY/MM/DD'),
          arrange: this.$mango.arrange.types[arrange] || arrange
        }
      }).splice((page - 1) * limit, limit) : []
    }
  }
}
</script>

<style lang="scss">
</style>
